import './App.css';
import Home from './Componets/Home/Home';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Pricing from './Componets/Pricing/Pricing';
import CaseStudies from './Componets/Casestudies/CaseStudies';
import IntegrationHome from './Componets/Integration/IntegrationHome';
import Blog from './Componets/Blog/Blog';
import Affiliate from './Componets/Affiliate/Affiliate';
import About from './Componets/About/About';
import Help from './Componets/Help/Help';
import Common from './Componets/CommonPage/Common';
// import 'animate.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

// Google Analytics
import ReactGA from 'react-ga4';

const TRACKING_ID = "G-QXBZEWTLKX";
ReactGA.initialize(TRACKING_ID);

function App() {

  useEffect(() => {
    // google analytics for pageview
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: "Home Page" });;
    AOS.init({
      duration: 1000, // Animation duration
    });
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path='/pricing' element={<Pricing />} />
          <Route path='/caseStudies' element={<CaseStudies />} />
          <Route path='/integration' element={<IntegrationHome />} />
          <Route path='/blog' element={<Blog />} />
          <Route path='/affiliate' element={<Affiliate />} />
          <Route path='/about' element={<About />} />
          <Route path='/help' element={<Help />} />
          <Route path='/common' element={<Common />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
